import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import RequirementBlockCardHeader from '../RequirementBlockCardHeader';

const QuestionBlock = ({ question, ...props }) => (
  <Box
    background={colors.gradient.aiPrimaryOpaque}
    borderRadius="md"
    flexBasis="100%"
    mb={4}
    px={3}
    py={4}
    {...props}
  >
    <RequirementBlockCardHeader displayName={question?.name ?? 'N/A'} />
    <Text color={colors.greyScale['700']} mt={3} textAlign="left" textStyle="bodySm">
      {question?.question ?? '–'}
    </Text>
  </Box>
);

QuestionBlock.propTypes = {
  question: PropTypes.shape({
    name: PropTypes.string,
    question: PropTypes.string
  })
};

export default QuestionBlock;
